// Helpers compartidos para mostrar la composición de un kit al cliente.
// Consolida items de la DB en una representación visual más limpia
// (ej. Cottonmax 3L + 1L → "Jabón lavarropas con suavizante · 4 L").
// IMPORTANTE: la DB conserva los items reales (afectan stock + costo).
// Esto solo cambia el display al cliente.

/** Grupos de SKUs que se consolidan en un solo bullet visual. */
export const KIT_DISPLAY_GROUPS = [
  {
    skus: ['CO02', 'C02'],
    nombre: 'Jabón lavarropas con suavizante',
    sumarLitros: true,
  },
]

/** Convierte presentación a litros (ej "3 L" → 3, "500 ml" → 0.5). */
export function presentacionALitros(pres) {
  if (!pres) return 0
  const sL = String(pres).match(/(\d+(?:[.,]\d+)?)\s*L\b/i)
  if (sL) return parseFloat(sL[1].replace(',', '.'))
  const sMl = String(pres).match(/(\d+(?:[.,]\d+)?)\s*m[lL]\b/i)
  if (sMl) return parseFloat(sMl[1].replace(',', '.')) / 1000
  return 0
}

/**
 * Toma la lista de productos del kit y aplica consolidaciones visuales.
 * Devuelve un array con `{ nombre, presentacion, cantidad, es_consolidado, ...orig }`.
 */
export function consolidarProductosKit(productos) {
  if (!Array.isArray(productos) || productos.length === 0) return []
  const usados = new Set()
  const resultado = []
  for (const group of KIT_DISPLAY_GROUPS) {
    const items = productos.filter(p => group.skus.includes(p.sku) && !p.es_regalo)
    if (items.length < 2) continue  // hay que tener al menos 2 items del grupo
    items.forEach(it => usados.add(it.sku))
    let presentacion = ''
    if (group.sumarLitros) {
      const totalL = items.reduce((s, it) => s + presentacionALitros(it.presentacion) * Number(it.cantidad || 1), 0)
      presentacion = totalL > 0 ? `${Number.isInteger(totalL) ? totalL : totalL.toFixed(1).replace('.', ',')} L` : ''
    }
    resultado.push({
      nombre: group.nombre,
      presentacion,
      cantidad: 1,
      es_consolidado: true,
    })
  }
  // Agregar el resto sin consolidar
  productos.forEach(p => {
    if (!usados.has(p.sku)) resultado.push(p)
  })
  return resultado
}

/**
 * Multiplica la primera unidad numérica de la presentación cuando cantidad > 1.
 * Ej: cantidad=2, presentación="12 rollos de 30m × 10cm" → "24 rollos de 30m × 10cm"
 */
export function presentacionTotal(cantidad, presentacion) {
  if (!presentacion) return ''
  const c = Number(cantidad) || 1
  if (c === 1) return presentacion

  // Si la presentación empieza con número + unidad de VOLUMEN/PESO de UNA pieza
  // (ml, mL, L, cc, g, kg), NO multiplicar el número.
  // Son 2 botellas de 500 ml, no 1 de 1000 ml.
  const reVolumenPeso = /^\s*\d+(?:[.,]\d+)?\s*(ml|mL|L|cc|g|kg)\b/i
  if (reVolumenPeso.test(presentacion)) {
    return `${presentacion} × ${c}`
  }

  // Resto (rollos, bolsas, unidades, packs, hojas, etc.): multiplicar el primer número.
  // Ej: "12 rollos de 30m × 10cm" × 2 → "24 rollos de 30m × 10cm"
  const m = presentacion.match(/^(\D*?)(\d+(?:[.,]\d+)?)/)
  if (!m) return presentacion + ` × ${c}`
  const prefix = m[1] || ''
  const num = parseFloat(m[2].replace(',', '.'))
  const total = num * c
  const totalStr = Number.isInteger(total) ? String(total) : total.toFixed(1).replace('.', ',')
  return prefix + totalStr + presentacion.slice(m[0].length)
}
